// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"8fce866a","204":"808cecca","270":"772c73fe","327":"d2fad7ab","393":"17f10f28","516":"baf6a67a","699":"e72b3465","703":"90502270","882":"452a1834","954":"59a58cb6"}[chunkId] + ".chunk.js";
};